import React from 'react'
import { Text, useColorModeValue, TextProps } from '@chakra-ui/react'
import { useHistory } from 'react-router-dom'

type CustomLinkProps = {
  title: string
  path: string
  active: boolean
} & TextProps

const CustomLink: React.FC<CustomLinkProps> = ({ title, path, active, ...rest }) => {
  const colorHover = useColorModeValue('orange.900', 'orange.50')
  const color = useColorModeValue('orange.800', 'orange.200')
  const history = useHistory()
  return (
    <Text
      position="relative"
      _before={{
        content: '""',
        borderBottom: '1px solid',
        borderColor: 'orange.300',
        position: 'absolute',
        top: '130%',
        left: 0,
        transition: 'width .3s ease-in-out 0s',
        width: 0,
        ...(active && {
          width: '100%'
        })
      }}
      _hover={{
        color: colorHover,
        _before: {
          width: '100%'
        }
      }}
      cursor="pointer"
      color={active ? color : undefined}
      key={path}
    >
      <Text onClick={() => history.push(path)} {...rest}>
        {title}
      </Text>
    </Text>
  )
}

export default CustomLink
